import React, {useState, useEffect, useContext} from 'react'
import axios from 'axios';

import ProoductDetailsSection from '@components/Products/ProductDetailsSection/ProoductDetailsSection'
//import ProductHighlightSection from '@components/Products/ProductHighlightSection.jsx'
import UseWindowSize from '@components/helpers/UseWindowSize.jsx'
import ProductSwiper from '@components/Home/Carousel/ProductSwiper.jsx'
import ProductReviewsSection from '@components/Products/ProductReviewsSection/ProductReviewsSection'
import QuickBuyContext from '@context/QuickBuyContext'
import QuickBuyModal from '@components/modal/QuickBuyModal'
import ReviewsPanel from '@components/ReviewsPanel/ReviewsPanel'
const SingleProductPage = ({product, recommendedProducts}) => {

    const { width } = UseWindowSize()

    const [openQuickBuyModal, setOpenQuickBuyModal] = useState(false)
    const { quickBuyData, setQuickBuyData, addToBagClicked, setAddToBagClicked, isAddToCart, setIsAddToCart } = useContext(QuickBuyContext)
    const [prod, setProd] =  useState(null);

    const [ratings, setRatings] = useState({})
    const [reviews, setReviews] = useState({})
    const [isLoading, setIsLoading] = useState(true)
    const [fitToSize, setFitToSize] = useState(false)
    
    useEffect(() => {
        if(quickBuyData)
            setOpenQuickBuyModal(true)
            setProd(quickBuyData)
            setIsAddToCart(false)
    }, [quickBuyData])

    const isValidJson = (str) => {
        try {
            JSON.parse(str);
            return true;
        } catch (e) {
            return false;
        }
    };

    useEffect(() => {
        const badge = product?.metafields?.find(item => item.key === "badge");
        const badgeValue = badge && isValidJson(badge?.value) ? JSON.parse(badge?.value) : [];

        const exists = badgeValue?.some(badge => badge.title === "Runs True to Size");

        if(exists) {
            setFitToSize(true)
        }

    }, [product]);

    useEffect(() => {
        const fetchReviews = async () => {
            try {
                const PRODUCT_ID = product?.shopifyId?.replace("gid://shopify/Product/", "");
                const response = await axios.get(`/get-reviews`, {
                    params: { productId: PRODUCT_ID }
                });
    
                
                const reviews = response?.data?.reviews || [];
    
                setReviews(reviews)
                
                const ratingCounts = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
    
                // Loop through reviews and count ratings
                reviews?.forEach(review => {
                    const rating = review?.review?.rating;
    
                    if (ratingCounts[rating] !== undefined) {
                        ratingCounts[rating]++;
                    }
                });
    
                // Convert object to array format
                const ratings = Object.entries(ratingCounts).map(([star, total]) => ({
                    star: Number(star),
                    total
                }));
                

                setRatings({ ratings });
    
                setIsLoading(false)
    
            } catch (error) {
                setIsLoading(false)
                console.error('Error fetching product reviews:', error.message);
            }
            
        };
    
        fetchReviews();
    
      }, []);

      
      
    
    useEffect(() => {
        if(addToBagClicked)
            setOpenQuickBuyModal(true)
            setProd(addToBagClicked)
            setIsAddToCart(true)
    }, [addToBagClicked])

    
    
    
    return (
        <React.Fragment>
            <section className="relative max-container pb-16 lg:py-16">
                <ProoductDetailsSection data={product} ratings={ratings} isLoading={isLoading} />
            </section>

            {/* <ProductHighlightSection /> */}
            <div className="max-container my-8 px-4" >
                <div className="text-[1rem]">RECOMMENDED</div>
                <div className="mt-4">
                {width && (
                    <ProductSwiper
                        products={recommendedProducts}
                        cardOptions={"no-tag no-wishlist"}
                        spaceBetween={5} 
						ariaLabel='recommended'
                        breakpoints = {{
							// value of key is min-width property
							320: {
								slidesPerView: 1.5,
								spaceBetween: 5,
							},
							350: {
								slidesPerView: 1.8,
								spaceBetween: 5,
							},
							380: {
								slidesPerView: 2,
								spaceBetween: 5,
							},
							500: {
								slidesPerView: 2.5,
								spaceBetween: 10,
							},
							640: {
								slidesPerView: 3,
								spaceBetween: 10,
							},
							768: {
								slidesPerView: 3.5,
							},
							769: {
								slidesPerView: 2.5,
							},
							900: {
								slidesPerView: 3,
							},
							1024: {
								slidesPerView: 3.5,
							},
							1280: {
								slidesPerView: 4.5,
							},
							1440: {
								slidesPerView: 5,
							}
						}}
						width={width <=  420 ? '160' : width <=  768 ? '194' : '262'}
						height={width <=  420 ? '240' : width <=  768 ? '280' : '389'}
						loop 
                    />
                )}
                </div>
            </div>
            

            <ProductReviewsSection ratings={ratings} reviews={reviews} isLoading={isLoading} fitToSize={fitToSize}  />

            <QuickBuyModal 
                isOpen={openQuickBuyModal}
                onClose={() => {
                setQuickBuyData(null)
                setOpenQuickBuyModal(false)
                setAddToBagClicked(null)
                setIsAddToCart(false)
                }}
                data={prod}
                isAddToCart={isAddToCart}
            />

            <ReviewsPanel ratings={ratings} reviews={reviews} fitToSize={fitToSize} product={product} />
        </React.Fragment>
    );
}

export default SingleProductPage;
